import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './index.scss'
import App from './App.tsx'
import { getPerformanceTimingService, PERFORMANCE_MARKS } from '@/app/services/performance/PerformanceTimingService'

// Mark app bootstrap start as early as possible
getPerformanceTimingService().mark(PERFORMANCE_MARKS.APP_BOOTSTRAP_START);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Register service worker for PWA
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err)
    })
  })
}
